function levenshtein(a, b) {
  if (a.length === 0) {
    return b.length;
  }
  if (b.length === 0) {
    return a.length;
  }

  const matrix = [];
  for (let i = 0; i <= b.length; i++) {
    matrix[i] = [ i ];
  }
  for (let j = 0; j <= a.length; j++) {
    matrix[0][j] = j;
  }

  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      if (b.charAt(i - 1) === a.charAt(j - 1)) {
        matrix[i][j] = matrix[i - 1][j - 1];
      }
      else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j] + 1,
        );
      }
    }
  }

  return matrix[b.length][a.length];
}

function score(reference, candidate) {
  if (!reference || !candidate) {
    return -Infinity;
  }

  const ref = reference.toLowerCase().trim();
  const cand = candidate.toLowerCase().trim();
  if (!ref || !cand) {
    return -Infinity;
  }

  if (ref === cand) {
    return 10000;
  }
  if (cand.includes(ref) || ref.includes(cand)) {
    return 5000 - Math.abs(cand.length - ref.length);
  }

  const distance = levenshtein(ref, cand);
  const maxLen = Math.max(ref.length, cand.length);
  if (distance / maxLen > 0.5) {
    return -Infinity;
  }

  return 1000 - distance;
}

export function pickBestFuzzyMatch(references, candidates, getCandidateName) {
  if (!Array.isArray(candidates) || candidates.length === 0) {
    return null;
  }
  const refs = (Array.isArray(references) ? references : [ references ]).filter(r => !!r);
  if (refs.length === 0) {
    return null;
  }

  let best = null;
  let bestScore = -Infinity;

  for (const candidate of candidates) {
    const candidateName = typeof getCandidateName === 'function' ? getCandidateName(candidate) : candidate;
    for (const ref of refs) {
      const s = score(ref, candidateName);
      if (s > bestScore) {
        bestScore = s;
        best = candidate;
      }
    }
  }

  if (bestScore <= 0) {
    return null;
  }

  return best;
}
